import IconBase from "react-icon-base";

export default function Icon(props) {
  return (
    <IconBase
      {...props}
      viewBox={"0 0 24 24"}
      dangerouslySetInnerHTML={{
        __html: `<svg width="100%" height="100%" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M256,0c-71.017,0-128.789,57.772-128.789,128.789S184.983,257.578,256,257.578s128.789-57.772,128.789-128.789 S327.017,0,256,0z M256,219.699c-50.127,0-90.91-40.783-90.91-90.91c0-50.127,40.783-90.91,90.91-90.91s90.91,40.783,90.91,90.91 C346.91,178.916,306.127,219.699,256,219.699z"/><path d="M256,303.033c-113.284,0-202.022,91.787-202.022,208.967h37.879c0-97.539,70.569-171.088,164.143-171.088 S420.143,414.467,420.143,512h37.879C458.022,394.821,369.284,303.033,256,303.033z"/></svg>`,
      }}
    />
  );
}
